/**
 * Mobile app page header — collection scroll collapse + back navigation.
 * Desktop untouched (script no-ops above 768px for collapse).
 */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 768px)');
  var NAV_CURRENT_KEY = 'skipp_nav_current';
  var NAV_PREVIOUS_KEY = 'skipp_nav_previous';

  function trackInternalNavigation() {
    try {
      var current = window.location.pathname + window.location.search;
      var stored = sessionStorage.getItem(NAV_CURRENT_KEY);
      if (stored && stored !== current) {
        sessionStorage.setItem(NAV_PREVIOUS_KEY, stored);
      }
      sessionStorage.setItem(NAV_CURRENT_KEY, current);
    } catch (e) {}
  }

  function getStoredPreviousPath() {
    try {
      return sessionStorage.getItem(NAV_PREVIOUS_KEY);
    } catch (e) {
      return null;
    }
  }

  function getSameOriginReferrerPath() {
    try {
      var ref = document.referrer;
      if (!ref) return null;
      var refUrl = new URL(ref);
      if (refUrl.origin !== window.location.origin) return null;
      if (refUrl.pathname + refUrl.search === window.location.pathname + window.location.search) {
        return null;
      }
      return refUrl.pathname + refUrl.search;
    } catch (e) {
      return null;
    }
  }

  function skippGoBack(fallbackUrl) {
    var currentPath = window.location.pathname + window.location.search;

    if (window.history.length > 1) {
      window.history.back();
      return;
    }

    var storedPrevious = getStoredPreviousPath();
    if (storedPrevious && storedPrevious !== currentPath) {
      window.location.href = storedPrevious;
      return;
    }

    var referrerPath = getSameOriginReferrerPath();
    if (referrerPath) {
      window.location.href = referrerPath;
      return;
    }

    if (fallbackUrl) {
      window.location.href = fallbackUrl;
    }
  }

  /**
   * Back for product / collection pages. Only returns to a page on this store;
   * external referrers (Instagram, ads, WhatsApp) and direct landings go home.
   */
  function skippGoBackInternal(fallbackUrl) {
    var home = fallbackUrl || '/';
    var referrerPath = getSameOriginReferrerPath();

    if (!referrerPath) {
      window.location.href = home;
      return;
    }

    // A tab opened from an internal link has a same-origin referrer but no history entry to go back to.
    if (window.history.length > 1) {
      window.history.back();
      return;
    }

    window.location.href = referrerPath;
  }

  function initBackNavigation() {
    document.addEventListener('click', function (event) {
      var internalTrigger = event.target.closest('[data-skipp-go-back-internal]');
      if (internalTrigger) {
        event.preventDefault();
        skippGoBackInternal(internalTrigger.getAttribute('data-skipp-go-back-fallback') || '/');
        return;
      }
      var trigger = event.target.closest('[data-skipp-go-back]');
      if (!trigger) return;
      event.preventDefault();
      var fallback = trigger.getAttribute('data-skipp-go-back-fallback') || '';
      skippGoBack(fallback || null);
    });
  }

  function setHeaderHeight(header) {
    if (!header) return;
    var h = header.offsetHeight;
    document.documentElement.style.setProperty('--skipp-app-header-height', h + 'px');
  }

  function initCollectionCollapse() {
    if (!MQ.matches) return;

    var header = document.querySelector('[data-app-header-collapsible]');
    var sentinel = document.querySelector('[data-app-header-scroll-sentinel]');
    if (!header || !sentinel) return;

    setHeaderHeight(header);

    if (!('IntersectionObserver' in window)) return;

    if (header._skippCollapseObserver) {
      header._skippCollapseObserver.disconnect();
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var collapsed = !entries[0].isIntersecting;
        header.classList.toggle('app-page-header--collapsed', collapsed);
        document.body.classList.toggle('skipp-plp-header-collapsed', collapsed);
        requestAnimationFrame(function () {
          setHeaderHeight(header);
        });
      },
      {
        root: null,
        rootMargin: '-' + (header.offsetHeight || 56) + 'px 0px 0px 0px',
        threshold: 0
      }
    );

    observer.observe(sentinel);
    header._skippCollapseObserver = observer;

    window.addEventListener(
      'resize',
      function () {
        if (!MQ.matches) return;
        setHeaderHeight(header);
      },
      { passive: true }
    );
  }

  /**
   * Product page: header floats transparent over the hero image and turns solid
   * once the hero has scrolled up behind it.
   */
  function initProductOverlay() {
    var header = document.querySelector('[data-app-header-overlay]');
    if (!header || header._skippOverlayBound) return;
    header._skippOverlayBound = true;

    var section = header.closest('.section-header');
    var ticking = false;

    function update() {
      ticking = false;
      var hero = document.querySelector('.skipp-pdp-premium .product__media-wrapper');
      var solid = true;
      if (MQ.matches && hero && hero.offsetHeight > 0) {
        solid = hero.getBoundingClientRect().bottom <= header.offsetHeight + 8;
      }
      header.classList.toggle('app-page-header--solid', solid);
      if (section) section.classList.toggle('skipp-app-header-solid', solid);
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    window.addEventListener('load', requestUpdate);
    update();
  }

  function init() {
    trackInternalNavigation();
    initBackNavigation();
    initCollectionCollapse();
    initProductOverlay();
  }

  trackInternalNavigation();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  window.skippGoBack = skippGoBack;
  window.skippGoBackInternal = skippGoBackInternal;
})();
